// extracted by mini-css-extract-plugin
module.exports = {"wrap":"qki8g","footer":"_24j97","help_link":"_2q_bt","agreement":"sIgJe","content":"_6XOz6"};